import { NoteAudioType } from '@models/note-audio-type.enum';
import { User } from '@models/user';

export class PatientNoteAudio {
  id: number = 0;
  patientNoteId: number = 0;
  noteAudioType: NoteAudioType;
  transcript: string;
  audioBlobUrl: string;
  createdDate: Date = new Date();
  createdById: string;
}
